import { CoworkApiError } from '../../api/coworkApi';

/** A build asked for from a site other than the one the Brand OS was built from (the API's 409 `site_changed`). */
export interface SiteChange { url: string; previousSite: string; newSite: string }

/** The site change behind a failed build call, or null when the error is anything else. */
export function siteChangeOf(err: unknown, url: string): SiteChange | null {
  if (!(err instanceof CoworkApiError) || err.status !== 409 || err.code !== 'site_changed') return null;
  const { previousSite, newSite } = err.body as { previousSite?: unknown; newSite?: unknown };
  if (typeof previousSite !== 'string' || typeof newSite !== 'string') return null;
  return { url, previousSite, newSite };
}

/** The API's 409 build_running: another build for this brand has not finished yet. */
export function isBuildRunning(err: unknown): boolean {
  return err instanceof CoworkApiError && err.status === 409 && err.code === 'build_running';
}
